import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import AtsLogo from "../assets/images/ats-logo2.png";

const defaultJobData = {
  company: "Bharat ATS",
  title: "Job Opportunity",
  recruiter: "Recruitment Team",
  location: "Not specified",
  experience: "Not specified",
  type: "Full-time",
  about: ["We would like to discuss this opportunity with you."],
  skills: [],
};

const decodeSkills = (value) => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return value.split(",").map((skill) => skill.trim()).filter(Boolean);
  }
};

const stripHtml = (value = "") =>
  value
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, " ")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();

const splitDescription = (value = "") => {
  const text = stripHtml(value);
  if (!text) return defaultJobData.about;
  return text
    .split(/(?<=[.?!])\s+/)
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, 6);
};

const parseUnsubscribeData = (search) => {
  const params = new URLSearchParams(search);
  return {
    company: params.get("company_name") || defaultJobData.company,
    title: params.get("job_title") || defaultJobData.title,
    recruiter: params.get("recruiter_name") || defaultJobData.recruiter,
    location: params.get("location") || defaultJobData.location,
    experience:
      params.get("min_exp") || params.get("max_exp")
        ? `${params.get("min_exp") || ""}${params.get("min_exp") && params.get("max_exp") ? " - " : ""}${params.get("max_exp") || ""}`.trim()
        : defaultJobData.experience,
    type: params.get("job_type") || defaultJobData.type,
    about: splitDescription(params.get("jd") || ""),
    skills: decodeSkills(params.get("skills")),
  };
};

const ConsentUnsubscribe = () => {
  const location = useLocation();
  const { token1 } = useParams();
  const [jobData] = useState(() => parseUnsubscribeData(location.search, token1));
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const unsubscribeToken =
    token1 && !token1.includes("=")
      ? token1
      : new URLSearchParams(location.search).get("unsubscribe_token") ||
        new URLSearchParams(location.search).get("token") ||
        new URLSearchParams(location.search).get("consent_token") ||
        "";
  useEffect(() => {
    document.title = "ATS - Unsubscribe";
  }, []);
useEffect(() => {
  if (location.search) {
    setTimeout(() => {
      window.history.replaceState({}, "", location.pathname);
    }, 10);
  }
}, [location.pathname, location.search]);
  const handleUnsubscribe = async () => {
  if (!unsubscribeToken) {
    Swal.fire({
      icon: "error",
      title: "Unsubscribe Failed",
      text: "Unable to find unsubscribe details.",
    });
    return;
  }

 
  setIsLoading(true);

  try {
    await axios.post(
      `/api/v1/unsubscribe/${unsubscribeToken}/`,
      {},
    );

    setSuccess(true);
    await Swal.fire({
      icon: "success",
      title: "Unsubscribed Successfully",
      text: "You have been unsubscribed from future communication for this opportunity.",
      imageUrl: AtsLogo,
      imageHeight: 80,
      confirmButtonText: "OK",
    });

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Unsubscribe Failed",
      text: error.response?.data?.message || "Unable to unsubscribe at this time.",
    });
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div className="card shadow-lg border-0 rounded-4" style={{ maxWidth: 520, width: "100%" }}>
        <div className="card-body p-4 text-center">
          <div className="mb-4">
            <img src={AtsLogo} alt="ATS Logo" style={{ width: 180, maxWidth: "100%" }} />
          </div>

          <h4 className="text-primary mb-3" style={{ fontWeight: 600 }}>
            {success ? "You are unsubscribed" : "Unsubscribe from this opportunity"}
          </h4>

          {!success ? (
            <>
              <p className="text-muted mb-4">
                Stop receiving communication for this role and prevent future scheduling links from being sent.
              </p>
              {/* <div className="mb-4 text-start">
                <div className="fw-semibold">Opportunity</div>
                <div>{jobData.title}</div>
                <div className="fw-semibold mt-3">Company</div>
                <div>{jobData.company}</div>
              </div> */}
              <button
                className="btn btn-danger w-100 py-2 fw-semibold"
                onClick={handleUnsubscribe}
                disabled={isLoading}
              >
                {isLoading ? "Please wait..." : "Unsubscribe"}
              </button>
            </>
          ) : (
            <>
              <p className="text-success mb-3">
                You have been successfully unsubscribed from future communication for this job.
              </p>
              {/* <button
                className="btn btn-outline-primary w-100 py-2 fw-semibold"
                onClick={() => window.location.assign("/")}
              >
                Return to Home
              </button> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsentUnsubscribe;
